import Assets from "./modules/Assets";
import Navigation from "./modules/Navigation";
import Search from "./modules/Search";
import Maps from "./modules/Maps";
import Locations from "./modules/Locations";
import LocationEdit from "./modules/LocationEdit";
import ProductsTabs from "./modules/ProductsTabs";
import ProductsBlock from "./modules/ProductsBlock";
import ExpandingTextBlock from "./modules/ExpandingTextBlock";
import Splide from "@splidejs/splide";
import { display_tabs } from "./modules/Tabs.js";

const googleApiKey = "AIzaSyDqfASoyJJ4jlzhl0d3jyViiPxVx4FHW8o"; // updated 2/1/2022
const googleClientID =
  "33520486636-fn2hq7d6okibs0l04orn5c6nbikjbum6.apps.googleusercontent.com";

const nav = new Navigation();
const search = new Search();
const locedit = new LocationEdit();
display_tabs();

if (
  document.querySelectorAll(".block-exptext") ||
  document.querySelectorAll(".ds-brand")
) {
  const exptext = new ExpandingTextBlock();
}
if (document.getElementById("location_googlemap")) {
  const maps = new Maps(googleApiKey, googleClientID) || null;
}
if (location.href.indexOf("products") > -1) {
  const products = new ProductsTabs();
}
if (document.querySelector(".locations__tabs")) {
  const locations = new Locations(googleApiKey, googleClientID);
}
if (document.querySelector(".dealer-page")) {
  const assets = new Assets();
}
if (document.querySelector(".products-block")) {
  const products_block = new ProductsBlock();
}

// Back to top button (in footer) functionality
const backToTopButton = document.querySelectorAll(".back-to-top");

backToTopButton.forEach((btn) => {
  btn.addEventListener("click", (e) => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  });
});

// Mobile blog widget dropdown - page linking
const widget = document.querySelectorAll(".sidebar__section--dropdown");

widget.forEach((dd) => {
  dd.addEventListener("change", (e) => {
    location.href = e.target.value;
  });
  // Set dropdown to value of page
  if (
    [...dd.options].find((o) => {
      return o.value === location.pathname;
    })
  ) {
    dd.value = location.pathname;
  }
});

// Configure Banner slider
if (document.getElementById("banner-slider")) {
  new Splide("#banner-slider", {
    type: "loop",
    perPage: 1,
    arrows: true,
    pagination: true,
    autoplay: true,
    cover: true,
    autoHeight: true,
    classes: {
      // Banner slider navigation classes
      arrows: "splide__arrows banner-slider__arrows",
      arrow: "splide__arrow banner-slider__arrow",
      prev: "splide__arrow--prev banner-slider__arrow--prev",
      next: "splide__arrow--next banner-slider__arrow--next",
      pagination: "splide__pagination banner-slider__pagination", // container
      page: "splide__pagination__page banner-slider__page", // each button
    },
    breakpoints: {
      992: {
        height: "360px",
      },
    },
  }).mount();
}
